
import { fetchStoresPage } from '@/assets/scripts/api'
import PageData from '@/mixins/PageData'
import SeeMore from '@/mixins/SeeMore'
import { store } from '@/assets/scripts/store'

const ITEM_PAGE_COUNT = 50

export default {
  name: 'StoresPage',

  mixins: [PageData, SeeMore],

  async asyncData({ payload }) {
    if (payload) {
      return { apiData: payload }
    }
    return { apiData: await fetchStoresPage() }
  },

  computed: {

    isMobile() {
      return store.isMobile
    },

    pageCount() {
      return this.apiData.content.stores
        ? Math.ceil(this.apiData.content.stores.length / ITEM_PAGE_COUNT)
        : 1
    },

    displayedItemCount() {
      return this.pageCurrent * ITEM_PAGE_COUNT
    },

    stores() {
      return (
        (this.apiData && this.apiData.content
          ? this.apiData.content.stores
          : null) || []
      )
    },

    markers() {
      return this.stores.filter(store => store.coordinates)
    },
  },
}
